export const flightOptionType = {
  baggage: "Baggage",
  itinerary0Baggage: "Outward baggage",
  itinerary1Baggage: "Return baggage",
  baggageWithText: "Add checked baggage",
  seatSelectionWithText: "Seat selection",
  mealWithText: "Meal request",
  upgradeWithText: "Upgrade",
};
